var render = function () {
  var _vm$currentRound$cont;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "activity-stage"
  }, [_c('div', [_c('figure', [_c('figcaption', [_c('b', {
    domProps: {
      "textContent": _vm._s(_vm.currentRound.title)
    }
  })]), _c('img', {
    attrs: {
      "src": (_vm$currentRound$cont = _vm.currentRound.contentImage) === null || _vm$currentRound$cont === void 0 ? void 0 : _vm$currentRound$cont.image.src,
      "alt": ""
    }
  }), _vm._l(_vm.currentRound.text, function (text) {
    return _c('figcaption', {
      key: text,
      staticClass: "text",
      domProps: {
        "textContent": _vm._s(text)
      }
    });
  })], 2), _c('div', {
    staticClass: "steps",
    class: {
      isMobileView: _vm.isMobile
    }
  }, [_c('span', [_c('b', {
    domProps: {
      "textContent": _vm._s(_vm.instructions)
    }
  })]), _vm._l(_vm.currentRound.steps, function (step) {
    return _c('text-display-dropdown', {
      key: ("dropdown-" + (step.id)),
      attrs: {
        "options": step.answers,
        "show-options": _vm.showOptions,
        "dropdown-id": ("dd-" + (step.id)),
        "selected-correct": _vm.handleCorrectSelect,
        "label": step.question,
        "step-index": step.stepIndex,
        "completed": _vm.completedIndexes.includes(step.stepIndex) ? true : false,
        "disable-drop-down": _vm.progress.stepIndex !== step.stepIndex ? _vm.disableDropDown : false
      }
    });
  })], 2)]), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }